module.exports = __webpack_public_path__ + "img/mastercard.eb2f4967.svg";